var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyPageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21398",
    "data-name": "\\uADF8\\uB8F9 21398",
    transform: "translate(0 -0.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21397",
    "data-name": "\\uADF8\\uB8F9 21397",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_27601",
    "data-name": "\\uC0AC\\uAC01\\uD615 27601",
    width: 32,
    height: 32,
    transform: "translate(0 0.35)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21392",
    "data-name": "\\uADF8\\uB8F9 21392",
    transform: "translate(3.244 5.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_27596",
    "data-name": "\\uC0AC\\uAC01\\uD615 27596",
    d: "M2.688,0H23.432a2.687,2.687,0,0,1,2.687,2.687V12.945a2.687,2.687,0,0,1-2.687,2.687H2.688A2.688,2.688,0,0,1,0,12.944V2.688A2.688,2.688,0,0,1,2.688,0Z",
    transform: "translate(0 6.192)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10122",
    "data-name": "\\uD328\\uC2A4 10122",
    d: "M90.32,26.417h.336l-.282-1.575c-.1-.552.115-.941.548-1.014a.717.717,0,0,1,.912.652l.3,1.936h.911l.442-1.918a.947.947,0,0,1,1.822,0l.433,1.918h.921l.3-1.936a.716.716,0,0,1,.911-.652c.425.073.637.462.539,1l-.292,1.584h.345a.48.48,0,0,1,.54.516.5.5,0,0,1-.54.544h-.531l-.486,2.715a1.047,1.047,0,0,1-.894.905.936.936,0,0,1-1.052-.742l-.637-2.878H93.93l-.637,2.878a.935.935,0,0,1-1.052.742,1.047,1.047,0,0,1-.894-.905l-.5-2.715H90.32a.5.5,0,0,1-.539-.544.48.48,0,0,1,.539-.516m2.186,2.4.3-1.339h-.514Zm1.654-2.4h.469L94.4,25.35Zm2.132,2.39.2-1.33h-.513Z",
    transform: "translate(-81.335 -13.448)",
    fill: "#343a40",
    stroke: "#343a40",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10123",
    "data-name": "\\uD328\\uC2A4 10123",
    d: "M82.925,18.742l18.721-4.269a1.535,1.535,0,0,1,1.7,1.279l1.8,3.684",
    transform: "translate(-79.592 -12.569)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10124",
    "data-name": "\\uD328\\uC2A4 10124",
    d: "M80.6,19.568c.274-.124,12.454-6.132,12.728-6.255a1.506,1.506,0,0,1,1.262.014,1.771,1.771,0,0,1,.884,1.015L96,15.817",
    transform: "translate(-79.333 -13.18)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPageIcon);
export default __webpack_public_path__ + "static/media/myPageIcon.a96584d7654bb60be8ca2f8c2efdd087.svg";
export { ForwardRef as ReactComponent };